import { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import {
  handleCatchErrors,
  responseDataFormat,
} from "../../API/middlewares/resolveRequests";
import {
  getCommunitiesApi,
  getMembersStatusApi,
  getStatusCountApi,
} from "../../API/services/homepage";
import { useSelector } from "react-redux";
import "./style.css";
import { Link } from "react-router-dom";
import LoadingPopup from "../layout/loadingPopup";

const HomePage = () => {
  const [statusCount, setStatusCount] = useState();
  const [communitiesList, setCommunitiesList] = useState();
  const [membersStatusCount, setMembersStatusCount] = useState();
  console.log(membersStatusCount);
  const token = useSelector((state) => state.login.userToken);
  const getStatusCount = async () => {
    let response;
    try {
      response = await getStatusCountApi(0, token);
      setStatusCount(response.data.data);
    } catch (e) {
      response = handleCatchErrors(e);
    } finally {
      return responseDataFormat(response);
    }
  };

  const getCommuniteies = async () => {
    let response;
    try {
      response = await getCommunitiesApi(token);
      setCommunitiesList(response.data.data);
    } catch (e) {
      response = handleCatchErrors(e);
    } finally {
      return responseDataFormat(response);
    }
  };

  const getMembersStatus = async () => {
    let response;
    try {
      response = await getMembersStatusApi(token);
      setMembersStatusCount(response.data.data);
    } catch (e) {
      response = handleCatchErrors(e);
    } finally {
      return responseDataFormat(response);
    }
  };

  useEffect(() => {
    getStatusCount();
    getCommuniteies();
    getMembersStatus();
  }, []);

  const state = {
    options: {
      chart: {
        stacked: true,
        zoom: {
          enabled: false,
        },
        parentHeightOffset: 0,
        toolbar: {
          show: false,
        },
      },

      legend: {
        show: true,
        showForSingleSeries: false,
        showForNullSeries: true,
        showForZeroSeries: true,
        position: "bottom",
        horizontalAlign: "center",
        floating: false,
        fontSize: "15px",
        fontFamily: "gssLight",
        fontWeight: 400,
        formatter: undefined,
        inverseOrder: false,
        width: undefined,
        height: undefined,
        tooltipHoverFormatter: undefined,
        customLegendItems: [],
        offsetX: 0,
        offsetY: 10,
        labels: {
          colors: undefined,
          useSeriesColors: false,
        },
        markers: {
          width: 12,
          height: 12,
          strokeWidth: 0,
          strokeColor: "#fff",
          fillColors: undefined,
          radius: 12,
          customHTML: undefined,
          onClick: undefined,
          offsetX: 3,
          offsetY: 0,
        },
        itemMargin: {
          horizontal: 10,
          vertical: 10,
        },
        onItemClick: {
          toggleDataSeries: true,
        },
        onItemHover: {
          highlightDataSeries: true,
        },
      },

      markers: {
        strokeWidth: 7,
        strokeOpacity: 1,
        strokeColors: ["#fff"],
        colors: ["#00F"],
      },

      stroke: {
        curve: "straight",
      },
      // colors: ["#0085b6", "#00d39c", "#ff0000"],
      colors: ["#00d39c", "#0085b6", "#ff0000"],
      xaxis: {
        crosshairs: {
          show: false,
        },
        labels: {
          style: {
            fontSize: "18px",
            fontWeight: 600,
            fontFamily: "gssLight",
          },
          offsetY: 5,
        },
        axisBorder: {
          show: true,
          color: "#78909C",
          height: 1,
          width: "100%",
          offsetX: 0,
          offsetY: 0,
        },
        axisTicks: {
          show: true,
          borderType: "solid",
          color: "#78909C",
          height: 6,
          offsetX: 0,
          offsetY: 0,
        },
        title: {
          text: "البلدان المسئولة",
          offsetX: 0,
          offsetY: 10,
          style: {
            color: undefined,
            fontSize: 25,
            fontFamily: "gssLight",
            fontWeight: 600,
            cssClass: "apexcharts-xaxis-title",
          },
        },
        categories: membersStatusCount?.countries?.map((item, index) => {
          return item.name;
        }),
      },
      yaxis: {
        crosshairs: {
          show: false,
        },
        labels: {
          style: {
            fontSize: "16px",
            fontFamily: "gssLight",
            fontWeight: 500,
          },
          rotate: 0,
          offsetX: 0,
          offsetY: 0,
        },
        axisBorder: {
          show: true,
          color: "#78909C",
          width: 1,
          height: "100%",
          offsetX: 5,
          offsetY: 0,
        },
        axisTicks: {
          show: true,
          borderType: "solid",
          color: "#78909C",
          height: 5,
          offsetX: 0,
          offsetY: 0,
        },
        title: {
          text: "عدد الإجراءات",
          offsetX: -140,
          offsetY: -100,
          style: {
            color: undefined,
            fontSize: 25,
            fontFamily: "gssLight",
            fontWeight: 600,
            cssClass: "apexcharts-xaxis-title",
          },
        },
      },
    },
    tooltip: {
      custom(data) {
        return `<div className='px-1 py-50'>
                <span>${
                  data.series[data.seriesIndex][data.dataPointIndex]
                } %</span>
              </div>`;
      },
    },

    series: [
      {
        name: "ثنائى",
        data: membersStatusCount?.countries?.map((item, index) => {
          return item.tasksBilateralcooperation;
        }),
      },
      {
        name: "تكتل",
        data: membersStatusCount?.countries?.map((item, index) => {
          return item.tasksconglomerate;
        }),
      },
      {
        name: "متعدد الأطراف",
        data: membersStatusCount?.countries?.map((item, index) => {
          return item.tasksMultilateral;
        }),
      },
    ],
  };
  const donut = {
    options: {},
    series: [
      statusCount?.bilateralcooperation,
      statusCount?.conglomerate,
      statusCount?.multilateral,
      //   statusCount?.notStarted,
    ],
    labels: [
      "current",
      "finished",
      "late",
      // "notStarted"
    ],
  };
  const options = {
    legend: {
      show: true,
      showForSingleSeries: false,
      showForNullSeries: true,
      showForZeroSeries: true,
      position: "bottom",
      horizontalAlign: "center",
      floating: false,
      fontSize: "15px",
      fontFamily: "gssLight",
      fontWeight: 400,
      formatter: undefined,
      inverseOrder: false,
      width: undefined,
      height: undefined,
      tooltipHoverFormatter: undefined,
      customLegendItems: [],
      offsetX: 0,
      offsetY: 0,
      labels: {
        colors: undefined,
        useSeriesColors: false,
      },
      markers: {
        width: 12,
        height: 12,
        strokeWidth: 0,
        strokeColor: "#fff",
        fillColors: undefined,
        radius: 12,
        customHTML: undefined,
        onClick: undefined,
        offsetX: 3,
        offsetY: 0,
      },
      itemMargin: {
        horizontal: 10,
        vertical: 0,
      },
      onItemClick: {
        toggleDataSeries: true,
      },
      onItemHover: {
        highlightDataSeries: true,
      },
    },
    labels: [
      "ثنائى",
      "تكتل",
      " متعدد الأطراف",
      // "إجراءات لم تبدأ",
    ],

    // colors: [
    //   "#0085b6",
    //   "#00d39c",
    //   "#ff0034",
    //   // "#ffa442"
    // ],
    colors: ["#00d39c", "#0085b6", "#ff0000"],
    dataLabels: {
      enabled: true,
      style: {
        fontSize: "16px",
        fontFamily: "gssLight",
        fontWeight: "bold",
      },
      formatter(val, opt) {
        return `${parseInt(val)} %`;
      },
    },
    plotOptions: {
      pie: {
        donut: {
          labels: {
            show: true,
            name: {
              fontSize: "1.3rem",
              fontFamily: "gssLight",
            },
            value: {
              fontSize: "1rem",
              fontFamily: "gssLight",
              formatter(val) {
                return `${parseInt(val)}`;
              },
            },
          },
        },
      },
    },
    responsive: [
      {
        breakpoint: 992,
        options: {
          chart: {
            height: 380,
          },
          legend: {
            position: "bottom",
          },
        },
      },
      {
        breakpoint: 576,
        options: {
          chart: {
            height: 320,
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  name: {
                    fontSize: "1.5rem",
                  },
                  value: {
                    fontSize: "1rem",
                  },
                  total: {
                    fontSize: "1.5rem",
                  },
                },
              },
            },
          },
        },
      },
    ],
    tooltip: {
      enabled: false,
    },
    // chart: {
    //   events: {
    //   dataPointSelection: (event, chartContext, config) => {
    //     if (periodicites.find(x => x.indicatorCount === parseInt(config.w.config.series[config.dataPointIndex]))) {
    //       console.log(periodicites.find(x => x.indicatorCount === parseInt(config.w.config.series[config.dataPointIndex])).id)
    //       history.push(`/indicator/landingPage/periodicities/${periodicites.find(x => x.indicatorCount === parseInt(config.w.config.series[config.dataPointIndex])).id}`)
    //     }
    //   }
    //   }
    // }
  };

  if (
    communitiesList?.pivots?.length > 0 &&
    statusCount &&
    membersStatusCount
  ) {
    return (
      <div className="d-flex flex-xl-row flex-column">
        <div className="d-flex flex-column col-xl-8 col-12 ps-5">
          {statusCount && (
            <div className="d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start my-5">
              <div className="donut">
                <Chart
                  options={options}
                  series={donut.series}
                  type="donut"
                  width="400"
                />
              </div>
              <Link
                to={`/tasks/search/5`}
                state={{
                  id: 1,
                }}
                className="d-flex flex-column text-decoration-none justify-content-center align-items-center py-4 mt-4 mt-lg-0 px-5"
                style={{
                  direction: "rtl",
                  backgroundColor: "#f2f2f2",
                  height: "fit-content",
                  borderRadius: 10,
                  boxShadow: "1px 1px 7px #ccc",
                }}
              >
                <img src="/assets/images/coo1.png" width={20} />
                <p
                  style={{ color: "#00d39c", fontSize: 21, fontWeight: "bold" }}
                  className="mb-0 pt-3"
                >
                  {statusCount.bilateralcooperation}&nbsp;
                  <span
                    style={{
                      color: "#000",
                      fontSize: 20,
                      fontWeight: "lighter",
                    }}
                  >
                    ثنائى
                  </span>
                </p>
              </Link>
              <Link
                to={`/tasks/search/5`}
                state={{
                  id: 2,
                }}
                className="d-flex flex-column text-decoration-none justify-content-center align-items-center mt-4 mt-lg-0 mx-5 py-4 px-5"
                style={{
                  direction: "rtl",
                  backgroundColor: "#f2f2f2",
                  height: "fit-content",
                  borderRadius: 10,
                  boxShadow: "1px 1px 7px #ccc",
                }}
              >
                <img src="/assets/images/coo2.png" width={22} />
                <p
                  style={{ color: "#0085b6", fontSize: 21, fontWeight: "bold" }}
                  className="mb-0 pt-3"
                >
                  {statusCount.conglomerate}&nbsp;
                  <span
                    style={{
                      color: "#000",
                      fontSize: 20,
                      fontWeight: "lighter",
                    }}
                  >
                    تكتل
                  </span>
                </p>
              </Link>
              <Link
                to={`/tasks/search/5`}
                state={{
                  id: 3,
                }}
                className="d-flex flex-column text-decoration-none justify-content-center align-items-center mt-4 mt-lg-0 py-4 px-5"
                style={{
                  direction: "rtl",
                  backgroundColor: "#f2f2f2",
                  height: "fit-content",
                  borderRadius: 10,
                  boxShadow: "1px 1px 7px #ccc",
                }}
              >
                <img src="/assets/images/coo3.png" width={22} />
                <p
                  style={{ color: "#ff0034", fontSize: 21, fontWeight: "bold" }}
                  className="mb-0 pt-3"
                >
                  {statusCount.multilateral}&nbsp;
                  <span
                    style={{
                      color: "#000",
                      fontSize: 20,
                      fontWeight: "lighter",
                    }}
                  >
                    متعدد الأطراف
                  </span>
                </p>
              </Link>
            </div>
          )}

          <div className="d-flex align-items-center pe-5">
            <img
              src="/assets/images/icons/proceduresDistribution.png"
              width={30}
              height={30}
            />
            <p className="mt-3 mb-2 px-3" style={{ fontSize: 25 }}>
              توزيع الإجراءات على البلدان
            </p>
          </div>
          <div className="mixed-chart pe-3">
            <Chart
              options={state.options}
              series={state.series}
              type="bar"
              // width="100%"
              height={"800px"}
            />
          </div>
        </div>
        <div
          className="d-flex flex-column col-xl-4 col-12 overflow-auto px-4 scrollHome fixedClassHome"
          style={{
            backgroundColor: "#f2f2f2",
            height: "100%",
            paddingBottom: 100,
          }}
        >
          <div className="d-flex align-items-center">
            <img
              src="/assets/images/icons/communities.png"
              width={25}
              height={25}
            />
            <p className="mt-3 px-2" style={{ fontSize: 25 }}>
              المحاور
            </p>
          </div>
          {communitiesList?.pivots?.map((item, index) => {
            return (
              <div
                className="d-flex flex-column justify-content-center p-4 mb-4"
                style={{
                  direction: "rtl",
                  backgroundColor: "white",
                  height: "fit-content",
                  borderRadius: 10,
                  boxShadow: "1px 1px 7px #ccc",
                }}
              >
                <Link
                  to={`/tasks/communities/${item.id + "&" + item.name}`}
                  className="hoverLinks text-decoration-none mb-2"
                  style={{ fontSize: 18, fontWeight: "bold" }}
                >
                  {item.name}
                </Link>
                <p style={{ fontSize: 18 }} className="text-muted">
                  إجمالي الإجراءات&nbsp;
                  <span
                    style={{ color: "#000", fontSize: 18, fontWeight: "bold" }}
                  >
                    {item.taskCount}
                  </span>
                </p>
                <div className="d-flex flex-wrap">
                  <div className="d-flex col-3 align-items-center">
                    <img src="/assets/images/coo1.png" width={18} />
                    <p
                      style={{
                        color: "#00d39c",
                        fontSize: 18,
                        fontWeight: "bold",
                      }}
                      className="mb-0 px-2"
                    >
                      {item.tasksBilateralcooperation}&nbsp;
                      <span
                        style={{
                          color: "#000",
                          fontSize: 18,
                          fontWeight: "lighter",
                        }}
                      >
                        ثنائى
                      </span>
                    </p>
                  </div>
                  <div className="d-flex col-3 align-items-center">
                    <img src="/assets/images/coo2.png" width={18} height={18} />
                    <p
                      style={{
                        color: "#0085b6",
                        fontSize: 18,
                        fontWeight: "bold",
                      }}
                      className="mb-0 px-2"
                    >
                      {item.tasksconglomerate}&nbsp;
                      <span
                        style={{
                          color: "#000",
                          fontSize: 18,
                          fontWeight: "lighter",
                        }}
                      >
                        تكتل
                      </span>
                    </p>
                  </div>
                  <div className="d-flex col-6 align-items-center">
                    <img src="/assets/images/coo3.png" width={18} height={18} />
                    <p
                      style={{
                        color: "#ff0034",
                        fontSize: 18,
                        fontWeight: "bold",
                      }}
                      className="mb-0 px-2"
                    >
                      {item.tasksMultilateral}&nbsp;
                      <span
                        style={{
                          color: "#000",
                          fontSize: 18,
                          fontWeight: "lighter",
                        }}
                      >
                        متعدد الأطراف
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  } else {
    return <LoadingPopup show={true} />;
  }
};

export default HomePage;
